//--------------------------NEXT VERSION--------------------------------//

import 'V2/app'

//--------------------------OLD VERSION--------------------------------//

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

import './plugins/iziToast.js';
import './plugins/inputmask.js';
